import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_161e54bf from 'nuxt_plugin_workbox_161e54bf' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_6c11fa76 from 'nuxt_plugin_nuxticons_6c11fa76' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_sentryserver_d597cdb2 from 'nuxt_plugin_sentryserver_d597cdb2' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2f7aa79f from 'nuxt_plugin_sentryclient_2f7aa79f' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_78322941 from 'nuxt_plugin_plugin_78322941' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_templatesplugine2c86674_60eef058 from 'nuxt_plugin_templatesplugine2c86674_60eef058' // Source: ./templates.plugin.e2c86674.js (mode: 'client')
import nuxt_plugin_googlegtag_219304d2 from 'nuxt_plugin_googlegtag_219304d2' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_nuxtvuexroutersync_40498f4b from 'nuxt_plugin_nuxtvuexroutersync_40498f4b' // Source: ./nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_adsbygoogle_920785ce from 'nuxt_plugin_adsbygoogle_920785ce' // Source: ./adsbygoogle.js (mode: 'all')
import nuxt_plugin_main_67a102c2 from 'nuxt_plugin_main_67a102c2' // Source: ./firebase-module/main.js (mode: 'all')
import nuxt_plugin_axios_5711273a from 'nuxt_plugin_axios_5711273a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_googleanalytics_6b31403a from 'nuxt_plugin_googleanalytics_6b31403a' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_googlemaps_c54ce192 from 'nuxt_plugin_googlemaps_c54ce192' // Source: ../plugins/google-maps (mode: 'all')
import nuxt_plugin_materialicons_67556430 from 'nuxt_plugin_materialicons_67556430' // Source: ../plugins/material-icons (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_disqus_2744ae75 from 'nuxt_plugin_disqus_2744ae75' // Source: ../plugins/disqus (mode: 'all')
import nuxt_plugin_mask_9266ba40 from 'nuxt_plugin_mask_9266ba40' // Source: ../plugins/mask (mode: 'all')
import nuxt_plugin_fragment_15353778 from 'nuxt_plugin_fragment_15353778' // Source: ../plugins/fragment (mode: 'all')
import nuxt_plugin_phoneinput_33fd2837 from 'nuxt_plugin_phoneinput_33fd2837' // Source: ../plugins/phone-input (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Happyly","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:domain","content":"happyly.com"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Happyly"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Happyly"},{"hid":"description","name":"description","content":"Healthy ways to gather, giveback, and connect with others."},{"hid":"theme-color","name":"theme-color","content":"black"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Happyly"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Healthy ways to gather, giveback, and connect with others."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:ital,wght@0,200;0,400;0,500;0,600;1,200;1,400;1,600&family=Quicksand:wght@700&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Poppins:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.c970ebc5.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64x64.96e5b4.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512x512.96e5b4.png","sizes":"512x512"}],"script":[{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3","defer":true},{"async":true,"src":"\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js"},{"innerHTML":"\n      (adsbygoogle = window.adsbygoogle || []).push({\n        google_ad_client: \"ca-pub-8644644279642732\",\n        enable_page_level_ads: false\n      });\n  "},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-720275126","async":true}],"style":[],"__dangerouslyDisableSanitizers":["script"],"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_161e54bf === 'function') {
    await nuxt_plugin_workbox_161e54bf(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_6c11fa76 === 'function') {
    await nuxt_plugin_nuxticons_6c11fa76(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_d597cdb2 === 'function') {
    await nuxt_plugin_sentryserver_d597cdb2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2f7aa79f === 'function') {
    await nuxt_plugin_sentryclient_2f7aa79f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_78322941 === 'function') {
    await nuxt_plugin_plugin_78322941(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugine2c86674_60eef058 === 'function') {
    await nuxt_plugin_templatesplugine2c86674_60eef058(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_219304d2 === 'function') {
    await nuxt_plugin_googlegtag_219304d2(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuexroutersync_40498f4b === 'function') {
    await nuxt_plugin_nuxtvuexroutersync_40498f4b(app.context, inject)
  }

  if (typeof nuxt_plugin_adsbygoogle_920785ce === 'function') {
    await nuxt_plugin_adsbygoogle_920785ce(app.context, inject)
  }

  if (typeof nuxt_plugin_main_67a102c2 === 'function') {
    await nuxt_plugin_main_67a102c2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5711273a === 'function') {
    await nuxt_plugin_axios_5711273a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_6b31403a === 'function') {
    await nuxt_plugin_googleanalytics_6b31403a(app.context, inject)
  }

  if (typeof nuxt_plugin_googlemaps_c54ce192 === 'function') {
    await nuxt_plugin_googlemaps_c54ce192(app.context, inject)
  }

  if (typeof nuxt_plugin_materialicons_67556430 === 'function') {
    await nuxt_plugin_materialicons_67556430(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_disqus_2744ae75 === 'function') {
    await nuxt_plugin_disqus_2744ae75(app.context, inject)
  }

  if (typeof nuxt_plugin_mask_9266ba40 === 'function') {
    await nuxt_plugin_mask_9266ba40(app.context, inject)
  }

  if (typeof nuxt_plugin_fragment_15353778 === 'function') {
    await nuxt_plugin_fragment_15353778(app.context, inject)
  }

  if (typeof nuxt_plugin_phoneinput_33fd2837 === 'function') {
    await nuxt_plugin_phoneinput_33fd2837(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
